const actionButtonTheme = `actionButton`;

export const styles = {
	position: {
		RIGHT: `${actionButtonTheme} ${actionButtonTheme}--right`
	}
};